module.exports = function(size) {
  if (!this.image) {
    return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
  }

  if (size === 'original') {
    return this.image;
  }
  return this.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
};
